// extracted by mini-css-extract-plugin
module.exports = {"text":"fields_text__3iv2O","list":"fields_list__90Zfd"};